import classNames from 'classnames';
import { useMemo } from 'react';
import Slider from '@/components/slider/Slider';
import useNewRecommendations from '../../hooks/useNewRecommendations';
import RecommendedCard from '@/components/v2/cart/LeftSection/RecommendedCard';
import { RECOMMENDATIONS_BREAKPOINTS } from '@/components/v2/cart/constants';
import { ProductSource } from '@/lib/analytics/types';
import i18n from '@/settings/i18n';

const t = i18n.init('product');

const PairItWith = ({
  isAccount = false,
  psku,
}: {
  isAccount?: boolean;
  psku: string;
}) => {
  const excludeProducts = useMemo(() => (psku ? [psku] : []), [psku]);

  const { products: recommendations, loading } = useNewRecommendations({
    psku,
    excludeProducts,
  });

  if (!psku) {
    return null;
  }

  // Nothing came back, so there is no section to show - not even a heading.
  if (!loading && recommendations.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames('w-full', {
        'reebelo-container': !isAccount,
      })}
    >
      <h2
        className={classNames('mb-2 font-semibold', {
          'text-lg md:text-xl': !isAccount,
          'text-base md:text-lg': isAccount,
        })}
      >
        {isAccount ? t`Related to your order` : t`Pair it with`}
      </h2>
      {loading ? (
        <Slider
          hideArrow
          breakpoints={RECOMMENDATIONS_BREAKPOINTS}
          className="mt-2 overflow-hidden"
        >
          {[1, 2, 3, 4].map((placeholder) => (
            <div
              key={placeholder}
              className="h-[229.5px] animate-pulse rounded-2xl bg-[#F2F2F2]"
            />
          ))}
        </Slider>
      ) : (
        <div className="relative">
          <Slider
            hideArrow
            breakpoints={RECOMMENDATIONS_BREAKPOINTS}
            className="mt-2 overflow-hidden"
          >
            {recommendations.map((sku, index) => {
              const offer = sku?.offers?.[0];
              const product = sku?.product;

              if (!sku || !offer || !product) {
                return null;
              }

              return (
                <RecommendedCard
                  key={sku.id}
                  sku={sku}
                  offer={offer}
                  product={product}
                  slotNumber={index + 1}
                  source={isAccount ? ProductSource.ACCOUNT : ProductSource.PDP}
                />
              );
            })}
          </Slider>
        </div>
      )}
    </div>
  );
};

export default PairItWith;
